import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function LabOrders({ user }) {
    const [orders, setOrders] = useState([]);
    const [patientsList, setPatientsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentOrder, setCurrentOrder] = useState({
        id: null,
        patient_id: '',
        lab_name: '',
        work_type: '',
        tooth_number: '',
        color_code: '',
        sent_date: new Date().toISOString().split('T')[0],
        expected_date: '',
        status: 'sent',
        price: ''
    });
    const [showOverdueOnly, setShowOverdueOnly] = useState(false);

    useEffect(() => {
        fetchOrders();
        fetchPatients();
    }, []);

    const fetchOrders = () => {
        axios.get('./backend/get_lab_orders.php')
            .then(res => {
                setOrders(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const fetchPatients = () => {
        axios.get('./backend/get_patients.php')
            .then(res => {
                if (Array.isArray(res.data)) setPatientsList(res.data);
            })
            .catch(err => console.error(err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = { ...currentOrder, doctor_id: user ? user.id : 1 };
        axios.post('./backend/save_lab_order.php', data)
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchOrders();
            })
            .catch(err => toast.error('İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu kaydı silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_lab_order.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchOrders();
                });
        }
    };

    const openModal = (order = null) => {
        if (order) {
            setCurrentOrder(order);
        } else {
            setCurrentOrder({
                id: null,
                patient_id: '',
                lab_name: '',
                work_type: '',
                tooth_number: '',
                color_code: '',
                sent_date: new Date().toISOString().split('T')[0],
                expected_date: '',
                status: 'sent',
                price: ''
            });
        }
        setShowModal(true);
    };

    const handleStatusChange = (id, newStatus) => {
        if (window.confirm('İş emri durumunu değiştirmek istediğinize emin misiniz?')) {
            axios.post('./backend/update_lab_order_status.php', { id, status: newStatus })
                .then(res => {
                    toast.success(res.data.message);
                    fetchOrders();
                })
                .catch(err => toast.error('Durum güncellenemedi.'));
        }
    };

    const isOverdue = (order) => {
        if (!order.expected_date) return false;
        if (order.status === 'received' || order.status === 'delivered') return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const expected = new Date(order.expected_date);
        return expected < today;
    };

    const filteredOrders = showOverdueOnly ? orders.filter(o => isOverdue(o)) : orders;

    // Laboratuvar adına göre gruplama
    const groupedOrders = filteredOrders.reduce((groups, order) => {
        const lab = order.lab_name || 'Diğer';
        if (!groups[lab]) {
            groups[lab] = [];
        }
        groups[lab].push(order);
        return groups;
    }, {});

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Laboratuvar Takibi</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                        className="add-btn" 
                        onClick={() => setShowOverdueOnly(!showOverdueOnly)}
                        style={{ background: showOverdueOnly ? '#e74a3b' : '#858796', boxShadow: 'none' }}
                    >
                        {showOverdueOnly ? 'Tümünü Göster' : <><img src="/uploads/iconpack/error.svg" alt="Uyarı" style={{ width: '18px', height: '18px' }} /> Gecikenler</>}
                    </button>
                    <button className="add-btn" onClick={() => openModal()}>+ Yeni İş Emri</button>
                </div>
            </div>

            <table className="data-table">
                <thead>
                    <tr>
                        <th>Tarih</th>
                        <th>Hasta</th>
                        <th>Lab & İşlem</th>
                        <th>Diş No / Renk</th>
                        <th>Beklenen</th>
                        <th>Durum</th>
                        <th>Ücret</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(groupedOrders).length > 0 ? (
                        Object.keys(groupedOrders).map(labName => (
                            <React.Fragment key={labName}>
                                <tr style={{ backgroundColor: '#f8f9fc' }}>
                                    <td colSpan="8" style={{ padding: '10px 15px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                            <span style={{ fontWeight: 'bold', color: '#4e73df' }}>🏢 {labName} <span style={{fontSize: '0.8rem', color: '#858796', fontWeight: 'normal'}}>({groupedOrders[labName].length} İş Emri)</span></span>
                                            <span style={{ fontWeight: 'bold', color: '#1cc88a' }}>Toplam: {groupedOrders[labName].reduce((sum, o) => sum + parseFloat(o.price || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                                        </div>
                                    </td>
                                </tr>
                                {groupedOrders[labName].map(o => (
                                    <tr key={o.id} style={
                                        o.status === 'received' 
                                            ? { backgroundColor: '#e8f5e9', borderLeft: '5px solid #1b5e20' } 
                                            : (isOverdue(o) ? { backgroundColor: '#ffebee', borderLeft: '5px solid #e74a3b' } : {})
                                    }>
                                        <td data-label="Tarih">{new Date(o.sent_date).toLocaleDateString()}</td>
                                        <td data-label="Hasta">{o.patient_name}</td>
                                        <td data-label="Lab & İşlem">
                                            <div><strong>{o.lab_name}</strong></div>
                                            <div style={{fontSize: '0.85rem', color: '#666'}}>{o.work_type}</div>
                                        </td>
                                        <td data-label="Diş No / Renk">{o.tooth_number} / {o.color_code}</td>
                                        <td data-label="Beklenen">{o.expected_date ? new Date(o.expected_date).toLocaleDateString() : '-'}</td>
                                        <td data-label="Durum">
                                            <select
                                                value={o.status}
                                                onChange={(e) => handleStatusChange(o.id, e.target.value)}
                                                style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '12px',
                                                    border: '1px solid #eaecf4',
                                                    fontSize: '0.8rem',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                    backgroundColor: o.status === 'received' ? '#e8f5e9' : (o.status === 'delivered' ? '#d1c4e9' : (o.status === 'in_progress' ? '#fff3cd' : '#e3f2fd')),
                                                    color: o.status === 'received' ? '#1b5e20' : (o.status === 'delivered' ? '#4a148c' : (o.status === 'in_progress' ? '#856404' : '#0d47a1')),
                                                    outline: 'none'
                                                }}
                                            >
                                                <option value="sent">Gönderildi</option>
                                                <option value="in_progress">İşlemde</option>
                                                <option value="received">Geldi</option>
                                                <option value="delivered">Teslim Edildi</option>
                                            </select>
                                        </td>
                                        <td data-label="Ücret">{parseFloat(o.price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                                        <td data-label="İşlemler">
                                            <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                                <button className="edit-btn" onClick={() => openModal(o)}>Düzenle</button>
                                                <button className="delete-btn" onClick={() => handleDelete(o.id)}>Sil</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr><td colSpan="8" style={{textAlign:'center'}}>Kayıt bulunamadı.</td></tr>
                    )}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{currentOrder.id ? 'İş Emri Düzenle' : 'Yeni İş Emri'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="labForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Hasta Seçiniz</label>
                                    <select value={currentOrder.patient_id} onChange={e => setCurrentOrder({...currentOrder, patient_id: e.target.value})} required style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                        <option value="">Seçiniz...</option>
                                        {patientsList.map(p => (
                                            <option key={p.id} value={p.id}>{p.full_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                    <div className="form-group">
                                        <label>Laboratuvar Adı</label>
                                        <input type="text" value={currentOrder.lab_name} onChange={e => setCurrentOrder({...currentOrder, lab_name: e.target.value})} required placeholder="Örn: DentLab" />
                                    </div>
                                    <div className="form-group">
                                        <label>Yapılacak İşlem</label>
                                        <input type="text" value={currentOrder.work_type} onChange={e => setCurrentOrder({...currentOrder, work_type: e.target.value})} required placeholder="Örn: Zirkonyum Kaplama" />
                                    </div>
                                    <div className="form-group">
                                        <label>Diş No</label>
                                        <input type="text" value={currentOrder.tooth_number} onChange={e => setCurrentOrder({...currentOrder, tooth_number: e.target.value})} placeholder="11, 21" />
                                    </div>
                                    <div className="form-group">
                                        <label>Renk Kodu</label>
                                        <input type="text" value={currentOrder.color_code} onChange={e => setCurrentOrder({...currentOrder, color_code: e.target.value})} placeholder="A2, B1" />
                                    </div>
                                    <div className="form-group">
                                        <label>Gönderim Tarihi</label>
                                        <input type="date" value={currentOrder.sent_date} onChange={e => setCurrentOrder({...currentOrder, sent_date: e.target.value})} />
                                    </div>
                                    <div className="form-group">
                                        <label>Beklenen Tarih</label>
                                        <input type="date" value={currentOrder.expected_date} onChange={e => setCurrentOrder({...currentOrder, expected_date: e.target.value})} />
                                    </div>
                                    <div className="form-group">
                                        <label>Durum</label>
                                        <select value={currentOrder.status} onChange={e => setCurrentOrder({...currentOrder, status: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                            <option value="sent">Gönderildi</option>
                                            <option value="in_progress">İşlemde</option>
                                            <option value="received">Geldi</option>
                                            <option value="delivered">Teslim Edildi</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Maliyet (TL)</label>
                                        <input type="number" step="0.01" value={currentOrder.price} onChange={e => setCurrentOrder({...currentOrder, price: e.target.value})} />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="labForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default LabOrders;